module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAA/ElEQVRIx2N4ziBMI8QwajTZRh/hELjNJEQTo5u0uGfI8NLEaHdfthhbDuobfYdJSCmCWT2E+RlVjL7JJFSpwVWhD0Kphhy2HqzmHqwZRpwQkVpVrkeUuHq1GJ90JpOOP4uzD1u0MXuAJbu7A5tSNLNqIvN2AX5KA+Qkh6B5EKu+O8sZVsFVfHyqIcyuXmyXWQWpE9arBfkMvVisHVg1w5kV/JlPsQlSLRpLDLls7VllYpkM3Fks3Fk7lbmpZrRlMKtyPPNWAf6VEnySWUx+rmzUMfoCq6CzM9slWCCc5BR0cGR9yChEBaMvMws+RRW5zyR0k0lotOQbREYDAHdtNimGx99kAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ma.png
// module id = 877
// module chunks = 0